import clsx from 'clsx';

import styles from './LoaderSpinner.module.scss';

type LoaderSpinnerProps = {
  size?: number;
  className?: string;
  fullHeight?: boolean;
  label?: string;
};

export const LoaderSpinner = ({
  size = 26,
  className,
  fullHeight = true,
  label = 'Loading…',
}: LoaderSpinnerProps) => {
  return (
    <div className={clsx(styles.wrapper, { [styles.fullHeight]: fullHeight }, className)}>
      <span className={styles.spinner} style={{ width: size, height: size }} aria-hidden="true" />{' '}
      {label}
    </div>
  );
};

export default LoaderSpinner;
